import * as algoliasearch from 'algoliasearch';

const client = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_KEY);
const stockIndex = client.initIndex(`${process.env.ENV_SHORTNAME}_stocks`);

const algoliaStocksAction = {
  methods: {
    async getAlgoliaStock(keywords) {
      const { hits } = await stockIndex.search(
        {
          query: keywords,
          facets: ['*'],
          facetFilters: [],
          page: 0,
          hitsPerPage: 50,
        },
      );

      return hits;
    },
  },
};

export default algoliaStocksAction;



// WEBPACK FOOTER //
// ./src/assets/js/algoliaStocksMixin.js